// extracted by mini-css-extract-plugin
export var google_map = "iframe-module--google_map--aa-VW";